module.exports = __webpack_public_path__ + "images/visibility-drops-blue-3f27b9b7.svg";